import './login.css';
import { AppContext } from '../../services/AppContext';
import { useNavigate, useLocation } from 'react-router-dom';
import React, { useState, useEffect, useContext } from 'react';
import { useTranslation } from 'react-i18next';

const ResetPassword = () => {
    const { t } = useTranslation();
    const location = useLocation();
    const { apiClient, setUser, setIsAuthorized } = useContext(AppContext);
    const navigate = useNavigate();
    const [password, setPassword] = useState('');

    const handleReset = async (e) => {
        e.preventDefault();

        try {
            const queryParams = new URLSearchParams(location.search);
            const token = queryParams.get('token');
            const result = await apiClient.resetPassword({
                token: token,
                newPassword: password
            });

            if (result.token) {
                const user = {
                    id: result.id,
                    role: result.role,
                    name: result.name
                };
                apiClient.setState({
                    token: result.token,
                    user: user
                });
                setIsAuthorized(true);
                setUser(user);
                navigate('/');
            }
        } catch (e) {
            console.error(t('pages.resetPassword.errorMessage'));
            navigate('/');
        }
    };

    useEffect(() => {
        const queryParams = new URLSearchParams(location.search);
        const token = queryParams.get('token');

        if (!token) {
            navigate('/');
        }
    }, [location, navigate]);

    return (
        <div className="login-container">
            <h3 className="login-title">{t('pages.resetPassword.title')}</h3>
            <form onSubmit={handleReset} className="login-form">
                <label htmlFor="password">{t('pages.resetPassword.passwordLabel')}</label>
                <input
                    type="password"
                    id="password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    required
                />
                <button type="submit" className="login-button">
                    {t('pages.resetPassword.submitButton')}
                </button>
            </form>
        </div>
    );
};

export default ResetPassword;